export default __webpack_public_path__ + "static/media/Specc-Logo.77526dec.svg";